import { render, staticRenderFns } from "./WebPartFormShopRunner.vue?vue&type=template&id=8b7bd710&scoped=true&"
import script from "./WebPartFormShopRunner.vue?vue&type=script&lang=js&"
export * from "./WebPartFormShopRunner.vue?vue&type=script&lang=js&"
import style0 from "./WebPartFormShopRunner.vue?vue&type=style&index=0&id=8b7bd710&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7bd710",
  null
  
)

export default component.exports